import { BaseService } from 'services/baseService';
import { TechnologyTypeModel } from 'types/models/TechnologyTypeModel';

class TechnologyTypeService extends BaseService<TechnologyTypeModel> {
  controllerName = 'technology-types';
}

export const technologyTypeService = new TechnologyTypeService();
